<template>
  <div>
    <send-email-form-component
    :contact-person-primary="true"
    :send-type="EMAIL_SEND_TYPE.GENERAL"></send-email-form-component>
  </div>
</template>
<script>
import SendEmailFormComponent from '@/views/Email/ManageEmail/components/SendEmailFormComponent'
import { EMAIL_SEND_TYPE } from '@/configs/constant'

export default {
  name: 'EmailGeneralComponent',
  components: { SendEmailFormComponent },
  data () {
    return {
      EMAIL_SEND_TYPE
    }
  }
}
</script>
